import {useState} from 'react';
import {useNavigate,useSearchParams,Link} from 'react-router-dom';
import {ArrowUpRight,Lock} from 'lucide-react';
import {Field,Label,Action,SEO,useClub} from '../components/Common';
import {api,errorText} from '../lib/api';

export default function Auth({reset=false}){
 const {refreshUser}=useClub();
 const navigate=useNavigate();
 const [search]=useSearchParams();
 const [email,setEmail]=useState('');
 const [password,setPassword]=useState('');
 const [forgot,setForgot]=useState(false);
 const [busy,setBusy]=useState(false);
 const [error,setError]=useState('');
 const [message,setMessage]=useState('');
 const submit=async e=>{
  e.preventDefault();setBusy(true);setError('');
  try{
   if(reset){
    await api.post('/auth/reset/confirm',{token:search.get('token'),password});
    setMessage('Your password is set. You can now sign in.');
   }else if(forgot){
    const r=await api.post('/auth/reset',{email});setMessage(r.data.message);
   }else{
    const r=await api.post('/auth/login',{email,password});
    await refreshUser();navigate(['member','applicant'].includes(r.data.role)?'/office':'/admin');
   }
  }catch(e){setError(errorText(e));}finally{setBusy(false);}
 };
 return <><SEO title={reset?'Set your password':'Member access'}/><div className="wrap"><section className="form-panel">
  <span className="small-monogram">MC</span><Label>YOUR PRIVATE OFFICE</Label>
  <h1 data-testid="auth-title">{reset?'A private beginning.':forgot?'Welcome, again.':<>A familiar <em>welcome.</em></>}</h1>
  <p>{reset?'Choose a strong password with at least 12 characters.':forgot?'We’ll email a private link to set or reset your password.':'Your membership. Your requests. Your direct line.'}</p>
  {message?<div className="info-banner" role="status" data-testid="auth-message">{message}{reset&&<Link to="/login" className="inline-link" style={{display:'block'}} data-testid="password-set-login">Sign in to your account →</Link>}</div>:
   <form onSubmit={submit} data-testid="auth-form">
    {!reset&&<Field id="auth-email" label="Email address" type="email" autoComplete="email" required value={email} onChange={e=>setEmail(e.target.value)}/>}
    {(!forgot||reset)&&<Field id="auth-password" label={reset?'New password':'Password'} type="password" autoComplete={reset?'new-password':'current-password'} required minLength={reset?12:1} maxLength={72} value={password} onChange={e=>setPassword(e.target.value)}/>}
    {error&&<div className="error-banner" role="alert" data-testid="auth-error">{error}</div>}
    <Action id="auth-submit" kind="dark wide" disabled={busy} type="submit">{busy?'One moment…':reset?'Set password':forgot?'Send private link':'Enter your private office'}<ArrowUpRight size={16}/></Action>
    {!reset&&<button type="button" className="inline-link" onClick={()=>{setForgot(!forgot);setError('');}} data-testid="auth-toggle-reset">{forgot?'Return to sign in':'First visit or forgotten password? Set your password.'}</button>}
   </form>}
  <div className="auth-bottom"><Lock size={13}/><span>Private access. By invitation only.</span></div>
  <Link className="text-link" to="/apply" data-testid="auth-apply">Not yet a member? Apply privately <ArrowUpRight size={16}/></Link>
 </section></div></>;
}